export class DevExpressDropdownOptions {
    width: string | number | (() => string | number);

    constructor(width: string | number | (() => string | number)) {
        this.width = width;
    }
}
